import _defineProperty from "/home/jenkins/workspace/Deployment/offer-submission-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/jenkins/workspace/Deployment/offer-submission-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function add(x, y) {
  if (y === undefined) {
    return function (yHolder) {
      return add(x, yHolder);
    };
  }

  return x + y;
} //taken from the last comment of https://gist.github.com/mkuklis/5294248


function curry(f) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function () {
    for (var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++) {
      p[_key] = arguments[_key];
    }

    return function (o) {
      return o.length >= f.length ? f.apply(void 0, _toConsumableArray(o)) : curry(f, o);
    }([].concat(_toConsumableArray(a), p));
  };
}

function adjustRaw(fn, index, arr) {
  var clone = arr.concat();
  return clone.map(function (val, key) {
    if (key === index) {
      return fn(arr[index]);
    }

    return val;
  });
}

var adjust = curry(adjustRaw);

function filterObject(fn, obj) {
  var willReturn = {};

  for (var _prop in obj) {
    if (fn(obj[_prop], _prop)) {
      willReturn[_prop] = obj[_prop];
    }
  }

  return willReturn;
}

function filter(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return filter(fn, arrHolder);
    };
  }

  if (arr === undefined) {
    return [];
  }

  if (!Array.isArray(arr)) {
    return filterObject(fn, arr);
  }

  var index = -1;
  var resIndex = 0;
  var len = arr.length;
  var willReturn = [];

  while (++index < len) {
    var value = arr[index];

    if (fn(value, index)) {
      willReturn[resIndex++] = value;
    }
  }

  return willReturn;
}

function all(condition, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return all(condition, arrHolder);
    };
  }

  return filter(condition, arr).length === arr.length;
}

function any(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return any(fn, arrHolder);
    };
  }

  var counter = 0;

  while (counter < arr.length) {
    if (fn(arr[counter], counter)) {
      return true;
    }

    counter++;
  }

  return false;
}

function allPass(conditions, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return allPass(conditions, xHolder);
    };
  }

  return !any(function (condition) {
    return !condition(x);
  }, conditions);
}

function always(x) {
  return function () {
    return x;
  };
}

function anyPass(conditions, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return anyPass(conditions, xHolder);
    };
  }

  return any(function (condition) {
    return condition(x);
  })(conditions);
}

function append(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return append(x, arrHolder);
    };
  }

  if (typeof arr === 'string') return "".concat(arr).concat(x);
  var clone = arr.concat();
  clone.push(x);
  return clone;
}

function assocRaw(prop, value, obj) {
  return Object.assign({}, obj, _defineProperty({}, prop, value));
}

var assoc = curry(assocRaw);

function both(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return both(x, yHolder);
    };
  }

  return function (input) {
    return x(input) && y(input);
  };
}

function complement(fn) {
  return function (input) {
    return !fn(input);
  };
}

function compose() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function () {
    var list = fns.slice();

    if (list.length > 0) {
      var fn = list.pop();
      var result = fn.apply(void 0, arguments);

      while (list.length > 0) {
        result = list.pop()(result);
      }

      return result;
    }

    return undefined;
  };
}

function concat(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return concat(x, yHolder);
    };
  }

  return typeof x === 'string' ? "".concat(x).concat(y) : [].concat(_toConsumableArray(x), _toConsumableArray(y));
}

function type(a) {
  var typeOf = typeof a;

  if (a === null) {
    return 'Null';
  } else if (a === undefined) {
    return 'Undefined';
  } else if (typeOf === 'boolean') {
    return 'Boolean';
  } else if (typeOf === 'number') {
    return 'Number';
  } else if (typeOf === 'string') {
    return 'String';
  } else if (Array.isArray(a)) {
    return 'Array';
  } else if (a instanceof RegExp) {
    return 'RegExp';
  }

  var asStr = a.toString();

  if (asStr.startsWith('async')) {
    return 'Async';
  } else if (asStr === '[object Promise]') {
    return 'Promise';
  } else if (asStr.includes('function') || asStr.includes('=>')) {
    return 'Function';
  }

  return 'Object';
}

function equals(a, b) {
  if (arguments.length === 1) {
    return function (bHolder) {
      return equals(a, bHolder);
    };
  }

  if (a === b) {
    return true;
  }

  var aType = type(a);

  if (aType !== type(b)) {
    return false;
  }

  if (aType === 'Array') {
    var aClone = Array.from(a);
    var bClone = Array.from(b);

    if (aClone.toString() !== bClone.toString()) {
      return false;
    }

    var loopArrayFlag = true;
    aClone.forEach(function (aCloneInstance, aCloneIndex) {
      if (loopArrayFlag) {
        if (aCloneInstance !== bClone[aCloneIndex] && !equals(aCloneInstance, bClone[aCloneIndex])) {
          loopArrayFlag = false;
        }
      }
    });
    return loopArrayFlag;
  }

  if (aType === 'Object') {
    var aKeys = Object.keys(a);

    if (aKeys.length !== Object.keys(b).length) {
      return false;
    }

    var loopObjectFlag = true;
    aKeys.forEach(function (aKeyInstance) {
      if (loopObjectFlag) {
        var aValue = a[aKeyInstance];
        var bValue = b[aKeyInstance];

        if (aValue !== bValue && !equals(aValue, bValue)) {
          loopObjectFlag = false;
        }
      }
    });
    return loopObjectFlag;
  }

  return false;
}

function contains(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return contains(x, arrHolder);
    };
  }

  var index = -1;
  var flag = false;

  while (++index < arr.length && !flag) {
    if (equals(arr[index], x)) {
      flag = true;
    }
  }

  return flag;
}

var dec = function dec(x) {
  return x - 1;
};

function flagIs(inputArgument) {
  return inputArgument === undefined || inputArgument === null || Number.isNaN(inputArgument) === true;
}

function defaultTo(defaultArgument) {
  for (var _len3 = arguments.length, inputArgument = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    inputArgument[_key3 - 1] = arguments[_key3];
  }

  if (arguments.length === 1) {
    return function (inputArgumentHolder) {
      return defaultTo(defaultArgument, inputArgumentHolder);
    };
  }

  if (arguments.length === 2) {
    return flagIs(inputArgument[0]) ? defaultArgument : inputArgument[0];
  }

  var limit = inputArgument.length - 1;
  var len = limit + 1;
  var ready = false;
  var holder;

  while (!ready) {
    var instance = inputArgument[limit - len + 1];

    if (len === 0) {
      ready = true;
    } else if (flagIs(instance)) {
      len = len - 1;
    } else {
      holder = instance;
      ready = true;
    }
  }

  return holder === undefined ? defaultArgument : holder;
}

function dissoc(prop, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return dissoc(prop, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return {};
  }

  var willReturn = {};

  for (var p in obj) {
    willReturn[p] = obj[p];
  }

  delete willReturn[prop];
  return willReturn;
}

function divide(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return divide(x, yHolder);
    };
  }

  return x / y;
}

function drop(dropNumber, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return drop(dropNumber, xHolder);
    };
  }

  return x.slice(dropNumber);
}

function dropLast(dropNumber, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return dropLast(dropNumber, xHolder);
    };
  }

  return x.slice(0, -dropNumber);
}

function either(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return either(x, yHolder);
    };
  }

  return function (input) {
    return x(input) || y(input);
  };
}

function endsWith(substr, str) {
  if (arguments.length === 1) {
    return function (strHolder) {
      return endsWith(substr, strHolder);
    };
  }

  return str.endsWith(substr);
}

function F() {
  return false;
}

function find(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return find(fn, arrHolder);
    };
  }

  return arr.find(fn);
}

function findIndex(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return findIndex(fn, arrHolder);
    };
  }

  var len = arr.length;
  var index = -1;

  while (++index < len) {
    if (fn(arr[index], index)) {
      return index;
    }
  }

  return -1;
}

function flatten(arr, willReturn) {
  willReturn = willReturn === undefined ? [] : willReturn;

  for (var i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      flatten(arr[i], willReturn);
    } else {
      willReturn.push(arr[i]);
    }
  }

  return willReturn;
}

function flipExport(fn) {
  return function () {
    for (var _len4 = arguments.length, input = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      input[_key4] = arguments[_key4];
    }

    if (input.length === 1) {
      return function (holder) {
        return fn(holder, input[0]);
      };
    } else if (input.length === 2) {
      return fn(input[1], input[0]);
    }

    return undefined;
  };
}

function flip(fn) {
  return flipExport(fn);
}

function mapObject(fn, obj) {
  var willReturn = {};

  for (var _prop2 in obj) {
    willReturn[_prop2] = fn(obj[_prop2], _prop2);
  }

  return willReturn;
}

function map(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return map(fn, arrHolder);
    };
  }

  if (arr === undefined) {
    return [];
  }

  if (!Array.isArray(arr)) {
    return mapObject(fn, arr);
  }

  var index = -1;
  var len = arr.length;
  var willReturn = Array(len);

  while (++index < len) {
    willReturn[index] = fn(arr[index], index);
  }

  return willReturn;
}

function forEach(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return forEach(fn, arrHolder);
    };
  }

  map(fn, arr);
  return arr;
}

function groupBy(fn, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return groupBy(fn, listHolder);
    };
  }

  var result = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var key = fn(item);

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);
  }

  return result;
}

function has(prop, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return has(prop, objHolder);
    };
  }

  return obj[prop] !== undefined;
}

function head(a) {
  if (typeof a === 'string') {
    return a[0] || '';
  }

  return a[0];
}

function identity(x) {
  return x;
}

function ifElse(condition, ifFn, elseFn) {
  if (ifFn === undefined) {
    return function (ifFnHolder, elseFnHolder) {
      return ifElse(condition, ifFnHolder, elseFnHolder);
    };
  } else if (elseFn === undefined) {
    return function (elseFnHolder) {
      return ifElse(condition, ifFn, elseFnHolder);
    };
  }

  return function (input) {
    var conditionResult = typeof condition === 'boolean' ? condition : condition(input);

    if (conditionResult === true) {
      return ifFn(input);
    }

    return elseFn(input);
  };
}

var inc = function inc(x) {
  return x + 1;
};

function includes(target, input) {
  if (arguments.length === 1) {
    return function (inputHolder) {
      return includes(target, inputHolder);
    };
  }

  var ok = Array.isArray(input) || typeof input === 'string';
  if (!ok) return false;
  return input.includes(target);
}

function indexBy(fn, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return indexBy(fn, listHolder);
    };
  }

  var result = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    result[fn(item)] = item;
  }

  return result;
}

function indexOf(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return indexOf(x, arrHolder);
    };
  }

  var index = -1;
  var length = arr.length;

  while (++index < length) {
    if (arr[index] === x) {
      return index;
    }
  }

  return -1;
}

function baseSlice(array, start, end) {
  var index = -1;
  var length = array.length;
  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

function init(a) {
  if (typeof a === 'string') {
    return a.slice(0, -1);
  }

  return a.length ? baseSlice(a, 0, -1) : [];
}

function is(xPrototype, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return is(xPrototype, xHolder);
    };
  }

  return x != null && x.constructor === xPrototype || x instanceof xPrototype;
}

function isNil(x) {
  return x === undefined || x === null;
}

function join(glue, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return join(glue, arrHolder);
    };
  }

  return arr.join(glue);
}

function keys(x) {
  return Object.keys(x);
}

function last(a) {
  if (typeof a === 'string') {
    return a[a.length - 1] || '';
  }

  return a[a.length - 1];
}

function lastIndexOf(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return lastIndexOf(x, arrHolder);
    };
  }

  var willReturn = -1;
  arr.map(function (value, key) {
    if (equals(value, x)) {
      willReturn = key;
    }
  });
  return willReturn;
}

function length(x) {
  return x.length;
}

function match(regex, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return match(regex, xHolder);
    };
  }

  var willReturn = x.match(regex);
  return willReturn === null ? [] : willReturn;
}

function merge(obj, newProps) {
  if (arguments.length === 1) {
    return function (newPropsHolder) {
      return merge(obj, newPropsHolder);
    };
  }

  return Object.assign({}, obj || {}, newProps || {});
}

function max(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return max(x, yHolder);
    };
  }

  return y > x ? y : x;
}

function maxBy(fn, x, y) {
  if (arguments.length === 2) {
    return function (yHolder) {
      return maxBy(fn, x, yHolder);
    };
  } else if (arguments.length === 1) {
    return function (xHolder, yHolder) {
      return maxBy(fn, xHolder, yHolder);
    };
  }

  return fn(y) > fn(x) ? y : x;
}

function min(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return min(x, yHolder);
    };
  }

  return y < x ? y : x;
}

function minBy(fn, x, y) {
  if (arguments.length === 2) {
    return function (yHolder) {
      return minBy(fn, x, yHolder);
    };
  } else if (arguments.length === 1) {
    return function (xHolder, yHolder) {
      return minBy(fn, xHolder, yHolder);
    };
  }

  return fn(y) < fn(x) ? y : x;
}

function modulo(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return modulo(x, yHolder);
  };
  return x % y;
}

function multiply(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return multiply(x, yHolder);
  };
  return x * y;
}

function none(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return none(fn, arrHolder);
  };
  return arr.filter(fn).length === 0;
}

function not(x) {
  return !x;
}

function nth(index, list) {
  if (arguments.length === 1) return function (listHolder) {
    return nth(index, listHolder);
  };
  var idx = index < 0 ? list.length + index : index;
  return Object.prototype.toString.call(list) === '[object String]' ? list.charAt(idx) : list[idx];
}

function omit(keys, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return omit(keys, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var keysValue = typeof keys === 'string' ? keys.split(',') : keys;
  var willReturn = {};

  for (var key in obj) {
    if (!keysValue.includes(key)) {
      willReturn[key] = obj[key];
    }
  }

  return willReturn;
}

function partialCurry(fn) {
  var inputArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (inputArgumentsHolder) {
    if (type(fn) === 'Async' || type(fn) === 'Promise') {
      return new Promise(function (resolve, reject) {
        fn(merge(inputArgumentsHolder, inputArguments)).then(resolve).catch(reject);
      });
    }

    return fn(merge(inputArgumentsHolder, inputArguments));
  };
}

function path(pathArr, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return path(pathArr, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var willReturn = obj;
  var counter = 0;
  var pathArrValue = typeof pathArr === 'string' ? pathArr.split('.') : pathArr;

  while (counter < pathArrValue.length) {
    if (willReturn === null || willReturn === undefined) {
      return undefined;
    }

    willReturn = willReturn[pathArrValue[counter]];
    counter++;
  }

  return willReturn;
}

function pathOrRaw(defaultValue, inputPath, inputObject) {
  return defaultTo(defaultValue, path(inputPath, inputObject));
}

var pathOr = curry(pathOrRaw);

function pick(keys, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return pick(keys, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var keysValue = typeof keys === 'string' ? keys.split(',') : keys;
  var willReturn = {};
  var counter = 0;

  while (counter < keysValue.length) {
    if (keysValue[counter] in obj) {
      willReturn[keysValue[counter]] = obj[keysValue[counter]];
    }

    counter++;
  }

  return willReturn;
}

function pickAll(keys, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return pickAll(keys, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var keysValue = typeof keys === 'string' ? keys.split(',') : keys;
  var willReturn = {};
  var counter = 0;

  while (counter < keysValue.length) {
    if (keysValue[counter] in obj) {
      willReturn[keysValue[counter]] = obj[keysValue[counter]];
    } else {
      willReturn[keysValue[counter]] = undefined;
    }

    counter++;
  }

  return willReturn;
}

function pipe() {
  for (var _len5 = arguments.length, fns = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    fns[_key5] = arguments[_key5];
  }

  return compose.apply(void 0, _toConsumableArray(fns.reverse()));
}

function pluck(keyToPluck, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return pluck(keyToPluck, arrHolder);
  };
  var willReturn = [];
  map(function (val) {
    if (!(val[keyToPluck] === undefined)) {
      willReturn.push(val[keyToPluck]);
    }
  }, arr);
  return willReturn;
}

function prepend(x, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return prepend(x, arrHolder);
  };

  if (typeof arr === 'string') {
    return "".concat(x).concat(arr);
  }

  var clone = arr.concat();
  clone.unshift(x);
  return clone;
}

function prop(key, obj) {
  if (arguments.length === 1) return function (objHolder) {
    return prop(key, objHolder);
  };
  return obj[key];
}

function propEq(key, x, obj) {
  if (x === undefined) {
    return function (xHolder, objHolder) {
      return propEq(key, xHolder, objHolder);
    };
  } else if (obj === undefined) {
    return function (objHolder) {
      return propEq(key, x, objHolder);
    };
  }

  return obj[key] === x;
}

function range(start, end) {
  if (arguments.length === 1) return function (endHolder) {
    return range(start, endHolder);
  };
  var willReturn = [];

  for (var i = start; i < end; i++) {
    willReturn.push(i);
  }

  return willReturn;
}

function reduce(fn, initialValue, arr) {
  if (initialValue === undefined) {
    return function (initialValueHolder, arrHolder) {
      return reduce(fn, initialValueHolder, arrHolder);
    };
  } else if (arr === undefined) {
    return function (arrHolder) {
      return reduce(fn, initialValue, arrHolder);
    };
  }

  return arr.reduce(fn, initialValue);
}

function reject(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return reject(fn, arrHolder);
  };
  return filter(function (x, i) {
    return !fn(x, i);
  }, arr);
}

function repeat(x, num) {
  if (arguments.length === 1) {
    return function (numHolder) {
      return repeat(x, numHolder);
    };
  }

  var willReturn = Array(num);
  return willReturn.fill(x);
}

function replace(regex, replacer, str) {
  if (replacer === undefined) {
    return function (replacerHolder, strHolder) {
      return replace(regex, replacerHolder, strHolder);
    };
  } else if (str === undefined) {
    return function (strHolder) {
      return replace(regex, replacer, strHolder);
    };
  }

  return str.replace(regex, replacer);
}

function reverse(arr) {
  var clone = arr.concat();
  return clone.reverse();
}

function sort(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return sort(fn, arrHolder);
  };
  var arrClone = arr.concat();
  return arrClone.sort(fn);
}

function sortBy(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return sortBy(fn, arrHolder);
    };
  }

  var arrClone = arr.concat();
  return arrClone.sort(function (a, b) {
    var fnA = fn(a);
    var fnB = fn(b);
    return fnA < fnB ? -1 : fnA > fnB ? 1 : 0;
  });
}

function split(glue, str) {
  if (arguments.length === 1) return function (strHolder) {
    return split(glue, strHolder);
  };
  return str.split(glue);
}

function splitEvery(num, x) {
  if (arguments.length === 1) return function (xHolder) {
    return splitEvery(num, xHolder);
  };
  var numValue = num > 1 ? num : 1;
  var willReturn = [];
  var counter = 0;

  while (counter < x.length) {
    willReturn.push(x.slice(counter, counter += numValue));
  }

  return willReturn;
}

function startsWith(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return startsWith(x, yHolder);
  };
  return y.startsWith(x);
}

function subtract(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return subtract(x, yHolder);
  };
  return x - y;
}

function T() {
  return true;
}

function tail(arr) {
  return drop(1, arr);
}

function take(num, x) {
  if (arguments.length === 1) return function (xHolder) {
    return take(num, xHolder);
  };

  if (typeof x === 'string') {
    return x.slice(0, num);
  }

  return baseSlice(x, 0, num);
}

function takeLast(num, x) {
  if (arguments.length === 1) return function (xHolder) {
    return takeLast(num, xHolder);
  };
  var len = x.length;
  var numValue = num > len ? len : num;

  if (typeof x === 'string') {
    return x.slice(len - numValue);
  }

  numValue = len - numValue;
  return baseSlice(x, numValue, len);
}

function tap(fn, x) {
  if (arguments.length === 1) return function (xHolder) {
    return tap(fn, xHolder);
  };
  fn(x);
  return x;
}

function test(regex, str) {
  if (arguments.length === 1) return function (strHolder) {
    return test(regex, strHolder);
  };
  return str.search(regex) !== -1;
}

function times(fn, num) {
  if (arguments.length === 1) return function (numHolder) {
    return times(fn, numHolder);
  };
  return map(fn, range(0, num));
}

function toLower(x) {
  return x.toLowerCase();
}

function toString(x) {
  return x.toString();
}

function toUpper(x) {
  return x.toUpperCase();
}

function trim(str) {
  return str.trim();
}

function uniq(arr) {
  var index = -1;
  var willReturn = [];

  while (++index < arr.length) {
    var value = arr[index];

    if (!contains(value, willReturn)) {
      willReturn.push(value);
    }
  }

  return willReturn;
}

function uniqWith(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return uniqWith(fn, arrHolder);
  };
  var index = -1;
  var len = arr.length;
  var willReturn = [];

  var _loop = function _loop() {
    var value = arr[index];
    var flag = any(function (willReturnInstance) {
      return fn(value, willReturnInstance);
    }, willReturn);

    if (!flag) {
      willReturn.push(value);
    }
  };

  while (++index < len) {
    _loop();
  }

  return willReturn;
}

function update(index, newValue, arr) {
  if (newValue === undefined) {
    return function (newValueHolder, arrHolder) {
      return update(index, newValueHolder, arrHolder);
    };
  } else if (arr === undefined) {
    return function (arrHolder) {
      return update(index, newValue, arrHolder);
    };
  }

  var arrClone = arr.concat();
  return arrClone.fill(newValue, index, index + 1);
}

function values(obj) {
  var willReturn = [];

  for (var key in obj) {
    willReturn.push(obj[key]);
  }

  return willReturn;
}

function without(itemsToOmit, collection) {
  return reduce(function (accum, item) {
    return !contains(item, itemsToOmit) ? accum.concat(item) : accum;
  }, [], collection);
}
/**
 * Taken from 
 * https://github.com/Nozbe/WatermelonDB/blob/master/src/utils/fp/zip/index.js
 */


function zip(left, right) {
  if (right === undefined) {
    return function (right) {
      return zip(left, right);
    };
  }

  var result = [];
  var length = Math.min(left.length, right.length);

  for (var i = 0; i < length; i++) {
    result[i] = [left[i], right[i]];
  }

  return result;
}

function zipObj(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return zipObj(x, yHolder);
  };
  return x.reduce(function (prev, xInstance, i) {
    prev[xInstance] = y[i];
    return prev;
  }, {});
}

export { add, adjust, all, allPass, always, any, anyPass, append, assoc, both, complement, compose, concat, contains, curry, dec, defaultTo, dissoc, divide, drop, dropLast, either, endsWith, equals, F, filter, find, findIndex, flatten, flip, forEach, groupBy, has, head, identity, ifElse, inc, includes, indexBy, indexOf, init, is, isNil, join, keys, last, lastIndexOf, length, map, match, merge, max, maxBy, min, minBy, modulo, multiply, none, not, nth, omit, partialCurry, path, pathOr, pick, pickAll, pipe, pluck, prepend, prop, propEq, range, reduce, reject, repeat, replace, reverse, sort, sortBy, split, splitEvery, startsWith, subtract, T, tail, take, takeLast, tap, test, times, toLower, toString, toUpper, trim, type, uniq, uniqWith, update, values, without, zip, zipObj };